function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState, useEffect, useRef } from "react";
import { Link, Autocomplete, IconSearch } from "../../";
import styled from "styled-components";
import { IconRemoveReversed } from "../../Icons";
const Container = styled.div`
  display: flex;
  justify-content: center;
  min-height: 40px;
  padding-left: 4px;
`;
const SearchLink = styled(Link)`
  font-size: 17px;
  line-height: 22px;
`;
export const LocationSearch = ({
  geolocation,
  onChange,
  ...props
}) => {
  const [showSearch, setShowSearch] = useState(false);

  const handleSearchOpen = () => setShowSearch(true);

  const searchRef = useRef();

  const handleSearch = async (value, e) => {
    const res = await fetch(`${process.env.REACT_APP_ENDPOINT_CITY}?q=(city:${value}*)+OR+(city:${value})&q.parser=lucene&sort=ranking+asc`);
    const {
      hits: {
        hit
      }
    } = await res.json();
    return hit.map(location => {
      const {
        fields: {
          id,
          city,
          state_id,
          state_name
        }
      } = location;
      return {
        id,
        text: `${city}, ${state_id}`,
        location: {
          fields: { ...location.fields,
            latitude: location.fields.lat,
            longitude: location.fields.lng,
            region_name: state_name
          }
        }
      };
    });
  };

  const handleLocationSelect = location => {
    if (location.location) {
      onChange(location.location.fields);
      setShowSearch(false);
    }
  };

  useEffect(() => {
    if (showSearch) {
      searchRef.current.focus();
    }
  }, [showSearch]);
  return React.createElement(Container, null, showSearch ? React.createElement(Autocomplete, {
    style: {
      width: "100%"
    },
    leftIcon: React.createElement(IconSearch, null),
    rightIcon: React.createElement(IconRemoveReversed, {
      style: {
        cursor: "pointer"
      },
      onClick: () => setShowSearch(false)
    }),
    placeholder: "Search for a City or Town" // selected={selected}
    ,
    onChange: handleLocationSelect,
    search: handleSearch,
    ref: searchRef
  }) : React.createElement(SearchLink, _extends({
    onClick: handleSearchOpen,
    "data-javelin-name": `change-location-open`
  }, props), geolocation.city, ", ", geolocation.region_name, " (Change Location)"));
};